"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildShareOrderPageLink = void 0;
const isLocal = process.env.NODE_ENV !== 'development';
const buildShareOrderPageLink = (orderBackofficeId, catalogSlug) => `http${!isLocal ? 's' : ''}://${window.location.host}/${catalogSlug}/pedido/${orderBackofficeId}/`;
exports.buildShareOrderPageLink = buildShareOrderPageLink;
